import { createVanIconComponent } from "./van"

const FlagOutlined = createVanIconComponent("flag-o")
export default FlagOutlined
